import Box from "@mui/material/Box";
import Stepper from "./components/Stepper";
import { usePageTitle } from "~/shared/ui/usePageTitle";

const AntecipeForm = () => {
  usePageTitle("Solicitar antecipação");
  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "#eef1f5" }}>
      <Stepper />
    </Box>
  );
};

export default AntecipeForm;
